export default [
  'DEU',
  'THA',
  'ITA',
  'and',
  'Germany',
  'FRO',
  'EMEA',
  'GBR',
  'HUN',
  'France',
  'LUX',
  'ESP',
  'PRT',
  'ZMB',
  'NLD',
  'IRL',
  'FIN',
  'Spain',
  'TWN',
  'CAN',
  'BGR',
  'MDA',
  'AUT',
  'JPN',
  'Lithuania',
  'CHE',
  'MKD',
  'FRA',
  'AFG',
  'UKR',
  'EST',
  'SRB',
  'Canada',
  'Austria',
  'LVA',
  'BEL',
  'BLR',
  'AZE',
  'ARM',
  'ZAF',
  'SVK',
  'POL',
  'Italy',
  'LTU',
  'CZE',
  'ROU',
  'IND',
  'Switzerland',
  'AUS',
  'USA',
  'Belgium',
  'DNK',
  'SWE',
  'RUS',
]
